"use strict";
exports.__esModule = true;
require('./truncate.css');
exports.default = {
  "truncate": "pf-c-truncate",
  "truncateEnd": "pf-c-truncate__end",
  "truncateStart": "pf-c-truncate__start"
};